import Cookies from 'js-cookie';

class FindAndReplace {
  static _instance;

  GCLID = 'gclid';
  paidPhoneNumber = '314-932-4921';
  organicPhoneNumber = '888-897-2776';

  willSwap = false;
  gaPhoneNumber = null;

  constructor() {
    this.links = new Map();
    this.links.set(
      'https://intelliapp.driverapponline.com/c/ltitruckingservices?r=website',
      'https://intelliapp.driverapponline.com/c/ltitruckingservices?r=adwords'
    );
    this.links.set(
      `tel:${this.organicPhoneNumber}`,
      `tel:${this.paidPhoneNumber}`
    );

    this.text = new Map();
    this.text.set(this.organicPhoneNumber, this.paidPhoneNumber);
  }

  static getInstance() {
    if (this._instance) {
      return this._instance;
    }
    this._instance = new FindAndReplace();
    return this._instance;
  }

  run() {
    this.bootstrap();

    if (this.willSwap) {
      this.swapNumbers();
    }
  }

  bootstrap() {
    const getParams =
      window.location.search.length > 0
        ? window.location.search
            .substr(1)
            .split('&')
            .map((t) => t.split('='))
        : [];

    const params = new Map();
    getParams.forEach(([key, val]) => params.set(key, val));

    if (
      params.has(this.GCLID) ||
      params.has('swap-debug') ||
      Cookies.get(this.GCLID) !== undefined
    ) {
      this.willSwap = true;
      if (Cookies.get(this.GCLID) === undefined && params.has(this.GCLID)) {
        Cookies.set(this.GCLID, params.get(this.GCLID));
      }
    }
  }

  setPhoneNumber(phone) {
    this.gaPhoneNumber = phone;
    this.text.set(this.organicPhoneNumber, this.gaPhoneNumber);
    this.text.set(this.paidPhoneNumber, this.gaPhoneNumber);
    this.links.set(
      `tel:${this.organicPhoneNumber}`,
      `tel:${this.gaPhoneNumber}`
    );
    this.links.set(`tel:${this.paidPhoneNumber}`, `tel:${this.gaPhoneNumber}`);
  }

  willPerformSwap() {
    return this.willSwap;
  }

  swapNumbers() {
    const atags = document.querySelectorAll('a');
    atags.forEach((a) => {
      if (this.links.has(a.href)) {
        a.href = this.links.get(a.href);
        if (this.text.has(a.innerText)) {
          a.innerText = this.text.get(a.innerText);
        }
      }
    });
  }
}

const ltiNumberSwap = () => {
  const far = FindAndReplace.getInstance();
  far.run();
};

window._ltiNumberSwap = ltiNumberSwap;

document.addEventListener('DOMContentLoaded', () => {
  window._ltiNumberSwap();
});

window.addEventListener('load', () => {
  const config = {
    ak: '61884686',
    cl: 'ceRlCIvRqNcBEI7k1MoD',
  };

  const googWcmGet = (b, d, e) => {
    window['_googWcmImpl'](2, b, config, d, null, new Date(), e);
  };

  window['_googWcmGet'] = googWcmGet;

  const instance = FindAndReplace.getInstance();
  if (instance.willPerformSwap()) {
    window._googWcmGet((phoneNumber) => {
      instance.setPhoneNumber(phoneNumber);
      instance.swapNumbers();
    }, instance.paidPhoneNumber);
  }
});
